import React from 'react';

interface AnalysisPeriodInfoProps {
  analysisPeriodStart: string;
  analysisPeriodEnd: string;
  generationDate: string;
}

const AnalysisPeriodInfo: React.FC<AnalysisPeriodInfoProps> = ({ 
  analysisPeriodStart, 
  analysisPeriodEnd, 
  generationDate 
}) => {
  return (
    <div className="row mb-3">
      <div className="col-12">
        <div className="card border-info">
          <div className="card-body py-2">
            <div className="row align-items-center">
              <div className="col-md-6">
                <small className="text-muted">
                  <i className="fas fa-calendar me-1"></i>
                  Analysis Period: {analysisPeriodStart} - {analysisPeriodEnd}
                </small>
              </div>
              <div className="col-md-6 text-md-end">
                <small className="text-muted">
                  <i className="fas fa-clock me-1"></i>
                  Generated: {generationDate}
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AnalysisPeriodInfo;